import { render } from "./PaymentClientComponent.vue?vue&type=template&id=3394b0e9&scoped=true"
import script from "./PaymentClientComponent.vue?vue&type=script&lang=js"
export * from "./PaymentClientComponent.vue?vue&type=script&lang=js"

import "./PaymentClientComponent.vue?vue&type=style&index=0&id=3394b0e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3394b0e9"]])

export default __exports__